import {
    CHANGE_PASSWORD_FAILED,
    GET_PROFILE_SUCCEEDED,
    LOADING_NEW_AVATAR_DONE, UPDATE_AVATAR,
    UPDATE_PROFILE_FAILED,
    UPDATE_SETTINGS_SUCCEEDED
} from "../actions/profile/actionTypes";
import {UPDATE_PROFILE_SUCCEEDED} from "../actions/profile/actionTypes";
import {UPDATE_AVATAR_SUCCEEDED} from "../actions/profile/actionTypes";

const initialState = {
    profile: null,
    settings: null,
    editAccountValidationErrors: {},
    changePasswordValidationErrors: {},
    nextAvatar: null
};

const reducer = (state = initialState, {type, ...action}) => {
    switch (type) {
        case GET_PROFILE_SUCCEEDED: {
            const {
                email,
                first_name: firstName,
                last_name: lastName,
                contact_number: contactNumber,
                date_of_birth: dateOfBirth,
                loyalty_points: loyaltyPoints,
                push_enabled: pushEnabled,
                feedback_enabled: feedbackEnabled,
                address,
                zip: zipCode,
                city,
                email_enabled: mailEnabled,
                avatar_url: avatar,
                client_company_name: companyName,
                registration_extra_field_label: extraFieldLabel,
                external_note: extraFieldValue,
            } = action.payload;

            return {
                ...state,
                profile: {
                    email,
                    firstName,
                    lastName,
                    contactNumber,
                    dateOfBirth,
                    loyaltyPoints,
                    address,
                    zipCode,
                    city,
                    avatar,
                    companyName,
                    extraFieldLabel,
                    extraFieldValue,
                },
                settings: {
                    pushEnabled,
                    mailEnabled,
                    feedbackEnabled
                }
            };
        }
        case UPDATE_PROFILE_SUCCEEDED: {
            const {
                firstName,
                lastName,
                birthDate: dateOfBirth,
                phoneNumber,
                companyName,
                address,
                zipCode,
                city,
                extraFieldValue,
            } = action.profile;
            return {
                ...state,
                profile: {
                    ...state.profile,
                    contactNumber: phoneNumber,
                    firstName,
                    lastName,
                    dateOfBirth,
                    companyName,
                    address,
                    zipCode,
                    city,
                    extraFieldValue,
                }
            };
        }
        case UPDATE_PROFILE_FAILED: {
            const {validationErrors: editAccountValidationErrors} = action;
            return {
                ...state,
                editAccountValidationErrors
            };
        }
        case UPDATE_AVATAR: {
            const {avatar: nextAvatar} = action;
            return {
                ...state,
                nextAvatar
            };
        }
        case UPDATE_AVATAR_SUCCEEDED: {
            const {avatar} = action;
            return {
                ...state,
                profile: {
                    ...state.profile,
                    avatar
                },
                nextAvatar: avatar
            };
        }
        case LOADING_NEW_AVATAR_DONE:
            return {
                ...state,
                nextAvatar: null
            };
        case CHANGE_PASSWORD_FAILED: {
            const {validationErrors: changePasswordValidationErrors} = action;
            return {
                ...state,
                changePasswordValidationErrors
            }
        }
        case UPDATE_SETTINGS_SUCCEEDED: {
            const {pushEnabled,  mailEnabled, feedbackEnabled} = action.settings;
            return {
                ...state,
                settings: {
                    pushEnabled,
                    mailEnabled,
                    feedbackEnabled
                }
            };
        }
        default:
            return state;
    }
};

export default reducer;
